import {memo} from 'react'

import PropTypes from 'prop-types'

import {useSuiContext} from '@s-ui/react-context'
import {Headline1} from '@adv-mt/ui/typography'

import {BASE_CLASS as PAGE_BASE_CLASS} from '../../config.js'
import Carfax from './carfax/index.js'
import Insurance from './insurance/index.js'
import SellVehicle from './sellVehicle/index.js'
import getAdvantagesVisibility from './getAdvantagesVisibility.js'

const BASE_CLASS = `${PAGE_BASE_CLASS}-advantages`

const Advantages = ({ad = {}, adType = {}, vehicleHistory}) => {
  const {domain, i18n} = useSuiContext()

  const config = domain.get('config')
  const advantagesSectionId = config.get('COMMON').AD_DETAIL_PAGE_SECTIONS.AD_DETAIL_PAGE_SECTION_IDS.ADVANTAGES

  // The sticky nav derives its ADVANTAGES entry from this same module, so the anchor exists
  // iff a card renders. Keep the early return anyway — defense in depth, not redundancy.
  const {showInsurance, showCarfax, showSellVehicle, showAdvantages} = getAdvantagesVisibility({
    ad,
    adType,
    vehicleHistory,
    config
  })

  if (!showAdvantages) {
    return null
  }

  return (
    <section id={advantagesSectionId} className={BASE_CLASS}>
      <div className={`${BASE_CLASS}-header`}>
        <Headline1>{i18n.t('COMMON.DETAIL_ADVANTAGES_TITLE')}</Headline1>
      </div>

      <div className={`${BASE_CLASS}-content`}>
        {showInsurance && <Insurance />}
        {showCarfax && <Carfax adId={ad.id} vehicleHistory={vehicleHistory} />}
        {showSellVehicle && <SellVehicle />}
      </div>
    </section>
  )
}

Advantages.displayName = 'Advantages'

Advantages.propTypes = {
  ad: PropTypes.shape({
    id: PropTypes.string,
    isProfessional: PropTypes.bool,
    monthlySubscriptionFee: PropTypes.number
  }),
  adType: PropTypes.shape({
    offerTypeId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
  }),
  vehicleHistory: PropTypes.shape({
    hasReport: PropTypes.bool,
    reportUrl: PropTypes.string
  })
}

export default memo(Advantages)
